import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { createUserApi, editUserApi } from "../../services/UserService";
import Select from "react-select";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getServiceCenterOptionApi } from "../../services/SearchService";
const AddUserModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [selectedServiceCenter, setSelectedServiceCenter] = useState(null);
  const [serviceCenterOption, setServicecenterOption] = useState([]);
  const [form, setForm] = useState({
    name: "",
    mobile_number: "",
    email: "",
    service_center: "",
    password: "",
  });
  const [error, setError] = useState({});
  const getServiceCenter = (id) => {
    getServiceCenterOptionApi()
      .then((res) => {
        const option = res?.data?.results || [];
        setServicecenterOption(option);
        if (id) {
          setSelectedServiceCenter(
            option.find((item) => item?.value == id) || null
          );
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (visible) {
      getServiceCenter(data?.service_center || "");
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        ...form,
        name: data?.name || "",
        mobile_number: data?.mobile_number || "",
        email: data?.email || "",
        password: "",
      });
    } else {
      setForm({
        name: "",
        mobile_number: "",
        email: "",
        service_center: "",
        password: "",
      });
      setSelectedServiceCenter(null);
    }

    setError({});
  };

  useEffect(() => {
    setForm({ ...form, service_center: selectedServiceCenter?.value || "" });
    if (error?.service_center && selectedServiceCenter?.value) {
      setError({ ...error, service_center: "" });
    }
  }, [selectedServiceCenter]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_number") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, [name]: numericValue }));

      if (numericValue.length === 10) {
        if (error?.mobile_number) {
          setError((prev) => ({ ...prev, mobile_number: "" }));
        }
      } else {
        setError((prev) => ({ ...prev, mobile_number: "Must be 10 digits" }));
      }
    } else if (name === "email") {
      const emailValue = value;
      const emailRegex = /^\S+@\S+\.\S+$/;
      setForm((prev) => ({ ...prev, [name]: emailValue }));
      if (emailRegex.test(emailValue)) {
        if (error?.email) {
          setError((prev) => ({ ...prev, email: "" }));
        }
      } else {
        setError((prev) => ({
          ...prev,
          email: "Invalid email format",
        }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
      if (value && error?.[name]) {
        setError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.name) error.name = "Name is required";
    if (!form.service_center)
      error.service_center = "Select at least one service center";

    if (!form.mobile_number?.trim()) {
      error.mobile_number = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile_number)) {
      error.mobile_number = "Enter a valid 10-digit mobile number";
    }
    if (!form.email?.trim()) {
      error.email = "Email is required";
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(form.email)
    ) {
      error.email = "Enter a valid email address";
    }
    if(!data){
      if(!form.password){
        error.password="Requied Field"
      }
    }

    setError(error);

    if (Object.keys(error).length === 0) {
      if (data) {
        updateUser();
      } else {
        addUser();
      }
    }
  };

  const addUser = () => {
    setLoading(true);
    createUserApi(form)
      .then(() => {
        toast.success("User created successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  const updateUser = () => {
    setLoading(true);
    const { password, ...rest } = form;
    editUserApi(data?.id || "", form?.password !== "" ? form : rest)
      .then(() => {
        toast.success("User update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{data ? "Update User" : "Add User"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <div className="d-flex gap-2 mb-2">
            <div className="flex-fill">
              <label className="form-label text-dark">Name</label>
              <input
                type="text"
                name="name"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                value={form.name}
                placeholder="John Doe"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error.name}</small>
              )}
            </div>
            <div className="flex-fill">
              <label className="form-label text-dark">Mobile Number</label>
              <input
                type="text"
                name="mobile_number"
                className={`form-control ${
                  error?.mobile_number ? "is-invalid" : ""
                }`}
                value={form.mobile_number}
                placeholder="9876543210"
                onChange={handleInputChange}
              />
              {error?.mobile_number && (
                <small className="text-danger">{error.mobile_number}</small>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mb-2">
            <div className="flex-fill">
              <label className="form-label text-dark">Email</label>
              <input
                type="text"
                name="email"
                className={`form-control ${error?.email ? "is-invalid" : ""}`}
                value={form.email}
                placeholder="service@dcw.com"
                onChange={handleInputChange}
              />
              {error?.email && (
                <small className="text-danger">{error.email}</small>
              )}
            </div>
            <div className="flex-fill">
              <label className="form-label text-dark">Password</label>
              <div className="position-relative">
                <input
                  type={showPwd ? "text" : "password"}
                  placeholder={data ? "optional" : "Password"}
                  name="password"
                  className={`form-control ${
                    error?.password ? "is-invalid" : ""
                  }`}
                  value={form?.password || ""}
                  onChange={handleInputChange}
                />

                <div
                  className="position-absolute top-50 translate-middle-y"
                  style={{ right: "15px", cursor: "pointer" }}
                  onClick={() => setShowPwd((prev) => !prev)}
                >
                  {!error.password &&
                    (showPwd ? (
                      <FaEye className="text-secondary" />
                    ) : (
                      <FaEyeSlash className="text-secondary" />
                    ))}
                </div>
              </div>
              {error?.password && (
                <small className="text-danger">{error.password}</small>
              )}
            </div>
          </div>
          <div className="mb-2">
            <label className="form-label text-dark">
              Select Service Center
            </label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select Vehicle"
              options={serviceCenterOption}
              value={selectedServiceCenter}
              onChange={setSelectedServiceCenter}
            />
            {error?.service_center && (
              <small className="text-danger">{error?.service_center}</small>
            )}
          </div>

          <code className="text-light">
            <strong>Note:</strong> All fields are required. Please enter a valid
            email and a reachable contact number.
          </code>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}{" "}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddUserModal;
